const __request = require(`yinzhilv-js-sdk/frontend/common-project/lib/data-service/default/__request/__request_contentType_json`);
const r = function (pParameter) {
  if (!pParameter) pParameter = {};
  pParameter.appKey = `trains`;
  return __request(pParameter);
};
module.exports = r;
